import { render } from "./ConfirmRegisterEC.vue?vue&type=template&id=af2667ea"
import script from "./ConfirmRegisterEC.vue?vue&type=script&lang=ts"
export * from "./ConfirmRegisterEC.vue?vue&type=script&lang=ts"
script.render = render

export default script